import axios from 'axios'

export const ImportStatusService = {
  fetchImportStatusList (queryParams) {
    if (queryParams) {
      return axios.get(`/api/v1/imports${queryParams}`)
    } else {
      return axios.get(`/api/v1/imports`)
    }
  },
  downloadImportedFile (queryParams, filename) {
    const FileDownload = require('js-file-download')
    return axios.get(`/api/v1/import/download${queryParams}`)
      .then((response) => {
        FileDownload(response.data, filename)
      })
  }
}
